import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
} from "@mui/material";
import ValueSelector from "./helper/ValueSelector";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useGlobalConfig } from "context/GlobalContext";

const NotificationForm = ({
  pilotId,
  setPilotId,
  startTime,
  setStartTime,
  endTime,
  setEndTime,
  eventName,
  setEventName,
  notificationStatus,
  setNotificationStatus,
  onFetchNotifications,
}) => {
  const { rc } = useGlobalConfig();
  const pilotOptions = ["10037", "10057", "10082"]; // Add more pilots as needed
  const eventOptions = ["MONTHLY_SUMMARY", "NEIGHBOURHOOD_COMPARISON","EV_WELCOME"]; // Add more events as needed
  const notificationStatuses = ["SCHEDULED", "REVOKED", "GENERATED"]; // Add more statuses as needed
  const today = Math.floor(Date.now()); // Current time in seconds

  // State for endpoint URL and access token
  const [endpointUrl, setEndpointUrl] = useState("");
  const [accessToken, setAccessToken] = useState("");

  // Load values from local storage on component mount
  useEffect(() => {
    const storedUrl = localStorage.getItem("endpointUrl");
    const storedToken = localStorage.getItem("accessToken");
    if (storedUrl) setEndpointUrl(storedUrl); rc.apiClient.setApiEndpoint(storedUrl);
    if (storedToken) setAccessToken(storedToken); rc.session.setAccessToken(storedToken);
  }, []);

  // Update local storage whenever endpointUrl or accessToken changes
  useEffect(() => {
    localStorage.setItem("endpointUrl", endpointUrl);
    rc.apiClient.setApiEndpoint(endpointUrl);
    localStorage.setItem("accessToken", accessToken);
    rc.session.setAccessToken(accessToken);
  }, [endpointUrl, accessToken]);

  const handleReset = () => {
    setPilotId("");
    setStartTime(null);
    setEndTime(null);
    setEventName("");
    setNotificationStatus("");
    setEndpointUrl("");
    setAccessToken("");
    localStorage.removeItem("endpointUrl");
    localStorage.removeItem("accessToken");
    window.location.reload(); // Optional: Reload the page
  };

  return (
    <div>
      <TextField
        label="Endpoint URL"
        value={endpointUrl}
        onChange={(e) => { setEndpointUrl(e.target.value);}}
        variant="outlined"
        margin="normal"
        required
        style={{ width: "300px", marginRight: "8px" }}
      />

      <TextField
        label="Access Token"
        value={accessToken}
        onChange={(e) => setAccessToken(e.target.value)}
        variant="outlined"
        margin="normal"
        required
        style={{ width: "300px" }}
      />

      <ValueSelector
        options={pilotOptions}
        fieldName="Select Pilot*"
        fieldValue={pilotId}
        onValueChange={setPilotId}
        mandatory={true}
      />

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateTimePicker
          label="Start Time"
          value={startTime}
          onChange={(newValue) => {
            setStartTime(newValue ? Math.floor(newValue.getTime()) : null);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              required
              variant="outlined"
              margin="normal"
              style={{ marginRight: "8px", width: "300px" }}
            />
          )}
          maxDateTime={new Date(today)} // Set max date to today
          inputFormat="dd/MM/yyyy HH:mm"
        />

        <DateTimePicker
          label="End Time"
          value={endTime}
          onChange={(newValue) => {
            setEndTime(newValue ? Math.floor(newValue.getTime()) : null);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              required
              variant="outlined"
              margin="normal"
              style={{ width: "300px" }}
            />
          )}
          maxDateTime={new Date(today)} // Set max date to today
          inputFormat="dd/MM/yyyy HH:mm"
        />
      </LocalizationProvider>

      <ValueSelector
        options={eventOptions}
        fieldName="Select Event*"
        fieldValue={eventName}
        onValue
        onValueChange={setEventName}
        mandatory={true}
      />

      <ValueSelector
        options={notificationStatuses}
        fieldName="Select Notification Status*"
        fieldValue={notificationStatus}
        onValueChange={setNotificationStatus}
        mandatory={true}
      />

      <Button
        variant="contained"
        color="primary"
        onClick={onFetchNotifications}
        style={{ margin: "16px 5px" }}
      >
        Fetch Notifications
      </Button>

      <Button
        variant="contained"
        color="secondary"
        onClick={handleReset} // Call the reset function
        style={{ margin: "16px 5px" }}
      >
        Reset Form
      </Button>
    </div>
  );
};

export default NotificationForm;
